import { render, staticRenderFns } from "./ProductTypeSelector.vue?vue&type=template&id=17ee93a2&scoped=true&"
import script from "./ProductTypeSelector.vue?vue&type=script&lang=ts&"
export * from "./ProductTypeSelector.vue?vue&type=script&lang=ts&"
import style0 from "./ProductTypeSelector.vue?vue&type=style&index=0&id=17ee93a2&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "17ee93a2",
  null
  
)

export default component.exports